import React from "react";
import Flexbox from "flexbox-react";
import "./GoalReportPage.css";
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import EmptyStateGoalChart from "./EmptyStateGoalChart";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const GoalCycleTrendsChart = ({ title, subtitle, trends, isCycleNotStarted }) => {
  const labels = ["January", "February", "March", "April", "May", "June"];

  const datasets = Object.values(trends).map(entry => ({
    label: entry.label,
    data: entry.data,
    borderColor: entry.borderColor,
    backgroundColor: entry.borderColor,
    tension: 0.3,
    pointStyle: "circle",
    pointRadius: 4,
    pointHoverRadius: 6,
    fill: false
  }));

  const data = { labels, datasets };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
      tooltip: { mode: "index", intersect: false }
    },
    interaction: { mode: "nearest", intersect: false },
    scales: {
      y: {
        beginAtZero: true,
        grid: { drawBorder: true }
      },
      x: {
        grid: { drawBorder: true }
      }
    }
  };

  return (
    <Flexbox display="flex" flexDirection="column" flexGrow={1} className="report-overview-box">
      <p className="title-text report-title">{title}</p>
      <p className="subtitle-text report-subtitle">{subtitle}</p>

      {isCycleNotStarted ? (
        <EmptyStateGoalChart />
      ) : (
        <>
          <div style={{ height: "300px", marginTop: "20px" }}>
            <Line data={data} options={options} />
          </div>
          {/* <Flexbox display="flex" justifyContent="center" className="legend-box">
        {datasets.map((ds, index) => (
          <LegendItem key={index} color={ds.borderColor} label={ds.label} />
        ))}
      </Flexbox> */}
        </>
      )}
    </Flexbox>
  );
};

const LegendItem = ({ color, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "6px" }}>
    <span
      style={{
        width: 14,
        height: 14,
        backgroundColor: color,
        borderRadius: "25%"
      }}
    ></span>
    <span className="title-text grey-text" style={{ fontSize: "15px" }}>
      {label}
    </span>
  </div>
);

export default GoalCycleTrendsChart;
